/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
/** No-op implementation of SpanProcessor */
export class NoopSpanProcessor {
    onStart(_span, _context) { }
    onEnd(_span) { }
    shutdown() {
        return Promise.resolve();
    }
    forceFlush() {
        return Promise.resolve();
    }
}
//# sourceMappingURL=NoopSpanProcessor.js.map